export default function Title({ terId, title, sectionId }) {
  return (
    <>
      {terId > 0 && (
        <div className="mapTitle" style={{ top: 5, left: 5, padding: 10 }}>
          <b>{title}</b>
        </div>
      )}
      {Number(sectionId.value) > -1 && (
        <div className="mapTitle" style={{ top: 50, left: 25 }}>
          <div
            style={{
              position: "relative",
              padding: 3,
            }}
          >
            {sectionId.label}
          </div>
        </div>
      )}
    </>
  );
}
